import { forEach, noop, once } from 'lodash/fp';

class Queue {
  constructor() {
    // @ts-expect-error - Automatic, Please fix when editing this file
    this.beforeAllFn = noop;
    // @ts-expect-error - Automatic, Please fix when editing this file
    this.queued = {};
    // @ts-expect-error - Automatic, Please fix when editing this file
    this.isStarted = false;
  }

  // @ts-expect-error - Automatic, Please fix when editing this file
  beforeAll(fn) {
    // @ts-expect-error - Automatic, Please fix when editing this file
    this.beforeAllFn = once(fn);
  }

  start() {
    // @ts-expect-error - Automatic, Please fix when editing this file
    this.isStarted = true;
    // @ts-expect-error - Automatic, Please fix when editing this file
    forEach((queuedFunction) => queuedFunction(), this.queued);
    // @ts-expect-error - Automatic, Please fix when editing this file
    this.queued = {};
  }

  // @ts-expect-error - Automatic, Please fix when editing this file
  add(key, fn) {
    // @ts-expect-error - Automatic, Please fix when editing this file
    this.beforeAllFn();
    // @ts-expect-error - Automatic, Please fix when editing this file
    if (this.isStarted) {
      fn();
    } else {
      // @ts-expect-error - Automatic, Please fix when editing this file
      this.queued[key] = fn;
    }
  }
}

export default Queue;

export const sharedInstance = new Queue();
